import { render, staticRenderFns } from "./Llamadas.vue?vue&type=template&id=27854db7"
import script from "./Llamadas.vue?vue&type=script&lang=js"
export * from "./Llamadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports